import { render, staticRenderFns } from "./SimpleCartIcon.vue?vue&type=template&id=b9728b5c"
import script from "./SimpleCartIcon.vue?vue&type=script&lang=js"
export * from "./SimpleCartIcon.vue?vue&type=script&lang=js"
import style0 from "./SimpleCartIcon.vue?vue&type=style&index=0&id=b9728b5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports